export const convertListToString = (list, connector, lastConnector) => {
  let result = "";
  if (list.length === 1) {
    result = list[0];
  }
  if (list.length > 1) {
    list.forEach((item, index) => {
      const itemName = item;
      if (index === list.length - 2) {
        result += `${itemName}${lastConnector} `;
      } else if (index === list.length - 1) {
        result += `${itemName}`;
      }
      else {
        result += `${itemName}${connector} `;
      }
    });
  }
  return result;
};
